import { render, staticRenderFns } from "./MapPowerItem.vue?vue&type=template&id=acdd9856"
import script from "./MapPowerItem.vue?vue&type=script&lang=js"
export * from "./MapPowerItem.vue?vue&type=script&lang=js"
import style0 from "./MapPowerItem.vue?vue&type=style&index=0&id=acdd9856&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports